import { FilterCategory, FilterFieldMeta } from '@/types/filterBuilder';

export const callFilterFields: FilterFieldMeta[] = [
  // Call Status
  {
    key: 'call_statuses',
    label: 'Call Status',
    category: 'status',
    inputType: 'multi-select',
    options: [
      { value: 'pending', label: 'Pending' },
      { value: 'in_progress', label: 'In Progress' },
      { value: 'completed', label: 'Completed' },
      { value: 'failed', label: 'Failed' },
      { value: 'voicemail', label: 'Voicemail' },
    ],
  },
  {
    key: 'was_successful',
    label: 'Was Successful',
    category: 'status',
    inputType: 'boolean',
    description: 'Call achieved its purpose (is_complete = true)',
  },
  {
    key: 'had_voicemail',
    label: 'Had Voicemail',
    category: 'status',
    inputType: 'boolean',
    description: 'Call went to voicemail',
  },

  // Call Type & Strategy
  {
    key: 'strategy_types',
    label: 'Strategy Type',
    category: 'type',
    inputType: 'multi-select',
    options: [
      { value: 'CONSENT', label: 'Consent' },
      { value: 'CHECK_IN', label: 'Check-in' },
      { value: 'PRE_CONSENT', label: 'Pre-Consent' },
      { value: 'MISSED_CONSENT', label: 'Missed Consent' },
      { value: 'PRE_CHECK_IN', label: 'Pre-Check-in' },
      { value: 'MISSED_CHECK_IN', label: 'Missed Check-in' },
    ],
  },
  {
    key: 'call_types',
    label: 'Call Direction',
    category: 'type',
    inputType: 'multi-select',
    options: [
      { value: 'dialin', label: 'Inbound' },
      { value: 'dialout', label: 'Outbound' },
    ],
  },

  // Date Filters
  {
    key: 'days_ago',
    label: 'Days Ago',
    category: 'date',
    inputType: 'text',
    placeholder: 'e.g., 7',
    description: 'Calls from the last N days',
  },
  {
    key: 'created_date',
    label: 'Created Date Range',
    category: 'date',
    inputType: 'date-range',
    rangeKeys: { start: 'created_after', end: 'created_before' },
  },

  // Patient
  {
    key: 'patient_name',
    label: 'Patient Name',
    category: 'patient',
    inputType: 'text',
    placeholder: 'Search by name...',
  },
  {
    key: 'patient_identifier',
    label: 'MRN / FHIR ID',
    category: 'patient',
    inputType: 'text',
    placeholder: 'MRN, external id or FHIR id',
  },
  {
    key: 'patient_phone',
    label: 'Patient Phone',
    category: 'patient',
    inputType: 'text',
    placeholder: 'e.g., 555-123-4567',
  },

  // Duration
  {
    key: 'duration_range',
    label: 'Duration (seconds)',
    category: 'advanced',
    inputType: 'text',
    placeholder: 'min,max (e.g., 60,300)',
    description: 'Format: min,max in seconds',
  },

  // Schedule
  {
    key: 'scheduled_today',
    label: 'Scheduled Today',
    category: 'schedule',
    inputType: 'boolean',
  },
  {
    key: 'scheduled_tomorrow',
    label: 'Scheduled Tomorrow',
    category: 'schedule',
    inputType: 'boolean',
  },
  {
    key: 'scheduled_this_week',
    label: 'Scheduled This Week',
    category: 'schedule',
    inputType: 'boolean',
  },
  {
    key: 'has_scheduled_calls',
    label: 'Has Scheduled Calls',
    category: 'schedule',
    inputType: 'boolean',
  },
  {
    key: 'scheduled_date',
    label: 'Scheduled Date Range',
    category: 'schedule',
    inputType: 'date-range',
    rangeKeys: { start: 'scheduled_after', end: 'scheduled_before' },
  },
];

export const callFilterCategories: FilterCategory[] = [
  {
    id: 'status',
    title: 'Call Status',
    filters: callFilterFields.filter((f) => f.category === 'status'),
  },
  {
    id: 'type',
    title: 'Call Type & Strategy',
    filters: callFilterFields.filter((f) => f.category === 'type'),
  },
  {
    id: 'date',
    title: 'Date Filters',
    filters: callFilterFields.filter((f) => f.category === 'date'),
  },
  {
    id: 'patient',
    title: 'Patient',
    filters: callFilterFields.filter((f) => f.category === 'patient'),
  },
  {
    id: 'schedule',
    title: 'Schedule',
    filters: callFilterFields.filter((f) => f.category === 'schedule'),
  },
  {
    id: 'advanced',
    title: 'Advanced',
    filters: callFilterFields.filter((f) => f.category === 'advanced'),
  },
];
